// src/api/trackingNumberService.js

// Use a shared axios client (api.js)
import api from "./api"; // convince yourself that the path is correct

// Если baseURL = "https://api.idlogichain.com/api",
// то итоговый путь будет: https://api.idlogichain.com/api/TrackingNumber
const API_URL = "/TrackingNumber";

// Get all tracking numbers
export const getTrackingNumbers = async () =>
    (await api.get(API_URL)).data;

// Get one tracking number by id
export const getTrackingNumber = async (id) =>
    (await api.get(`${API_URL}/${id}`)).data;

// Create a new tracking number
export const createTrackingNumber = async (data) =>
    (await api.post(API_URL, data)).data;

// Update an existing tracking number
export const updateTrackingNumber = async (id, data) =>
    (await api.put(`${API_URL}/${id}`, data)).data;

// Delete a tracking number
export const deleteTrackingNumber = async (id) =>
    (await api.delete(`${API_URL}/${id}`)).data;

export default {
    getTrackingNumbers,
    getTrackingNumber,
    createTrackingNumber,
    updateTrackingNumber,
    deleteTrackingNumber,
};
